export interface SkeletonJointDependenciesProps {
  nose: 'nose';
  leftEye: 'leftEye';
  rightEye: 'rightEye';
  leftEar: 'leftEar';
  rightEar: 'rightEar';
  leftWrist: 'leftElbow';
  leftElbow: 'leftShoulder';
  rightWrist: 'rightElbow';
  rightElbow: 'rightShoulder';
  leftShoulder: 'rightShoulder';
  rightShoulder: 'leftShoulder';
  leftHip: any;
  rightHip: any;
  leftAnkle: 'leftKnee';
  leftKnee: 'leftHip';
  rightAnkle: 'rightKnee';
  rightKnee: 'rightHip';
  [key: string]: any;
}

const Dependencies: SkeletonJointDependenciesProps = {
  nose: 'nose',
  leftEye: 'leftEye',
  rightEye: 'rightEye',
  leftEar: 'leftEar',
  rightEar: 'rightEar',
  leftWrist: 'leftElbow',
  leftElbow: 'leftShoulder',
  rightWrist: 'rightElbow',
  rightElbow: 'rightShoulder',
  leftShoulder: 'rightShoulder',
  rightShoulder: 'leftShoulder',
  leftHip: ['leftShoulder', 'rightHip'],
  rightHip: ['rightShoulder', 'leftHip'],
  leftAnkle: 'leftKnee',
  leftKnee: 'leftHip',
  rightAnkle: 'rightKnee',
  rightKnee: 'rightHip',
};

export default Dependencies;
